// utils/detectBrowser.js
import Bowser from 'bowser';

export const detectBrowser = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const browserName = browser.getBrowserName();
  const browserVersion = browser.getBrowserVersion();
  const platformType = browser.getPlatformType();
  
  return {
    name: browserName,
    version: browserVersion,
    platform: platformType,
  };
};